// import { FaYoutube } from "react-icons/fa";
import { TiSocialInstagram } from "react-icons/ti";

import { useContext } from "react";
import { I18nContext } from "../i18n/useI18n";

export const Footer: any = () => {
  const { t } = useContext(I18nContext);
  return (
    <footer className="bg-[#d5d7ff] py-8 flex flex-col items-center">
      <div className="container mx-auto flex flex-col md:flex-row justify-between  px-4">
        {/* Logos à esquerda */}
        <div className="gap-3 flex flex-col justify-between items-center">
          <img
            src={"https://static.igem.wiki/teams/5058/imgs/osiris.svg"}
            alt="OSIRIS Logo"
            width={80}
            height={80}
          />
          <img
            src={"https://static.igem.wiki/teams/5058/imgs/logo.svg"}
            alt="YOB3 Logo"
            width={116}
            height={80}
          />
        </div>

        {/* Contato e Mídias Sociais */}
        <div className="flex flex-col text-center items-center justify-center  mt-8 md:mt-0">
          <p className="text-lg font-bold">{t("pages.footer.titles.contact")}</p>
          <p className="text-blue-900 mb-4">
            <a
              target="_blank"
              rel="noreferrer"
              href="mailto:osirisrioufrj@gmail.com"
            >
              osirisrioufrj@gmail.com
            </a>
          </p>
          <p className="text-lg font-bold">{t("pages.footer.titles.social")}</p>
          <div className="flex justify-center ">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://instagram.com/osirisrioufrj"
            >
              <TiSocialInstagram size={40} />
            </a>
            {/* <a href="#">
              <FaYoutube size={40} />
            </a> */}
          </div>
        </div>

        {/* Logos à direita */}
        <div className="flex flex-col items-center  justify-between md:items-end mt-8 md:mt-0">
          <img
            src={
              "https://static.igem.wiki/teams/5058/imgs/ufrj-horizontal-negativa-telas.png"
            }
            alt="UFRJ Logo"
            width={128}
            height={32}
            className="mb-2"
          />
          <img
            src={
              "https://static.igem.wiki/teams/5058/imgs/logo-faperj-branco-completo.png"
            }
            alt="FAPERJ Logo"
            width={128}
            height={16}
            className="mb-4"
          />
          <img
            src={"https://static.igem.wiki/teams/5058/imgs/cnpq.png"}
            alt="CNPq Logo"
            width={128}
            height={32}
            className="mb-4"
          />
        </div>
      </div>

      <div className="mt-4 text-center">
        <p className="text-xs text-blue-900">
          {t("pages.footer.copyright")}{" "}
          <a
            href="http://gitlab.igem.org/2024/rio-ufrj-brazil"
            className="underline"
            target="_blank"
            rel="noreferrer"
          >
            http://gitlab.igem.org/2024/rio-ufrj-brazil
          </a>
        </p>
      </div>
    </footer>
  );
};
